module.exports = __webpack_public_path__ + "img/chama_violeta.7ab20a41.jpeg";